export const MREC_TILES = {
  DASHBOARD: 'mrec_tiles_dashboard',
  CLAIMS: 'mrec_tiles_claim_creation',
  LIVEVET: 'live_vet'
};

export const FAQ_CODENAME = {
  SUB_PAGE: 'subpages',
  HELP_CENTRE: 'helpcentre',
  LIVE_VET: 'livevet',
  MAKE_A_CLAIM: 'makeaclaim',
  VERIFICATION: 'verification',
  VERIFY_EMAIL: 'verifyemail',
  VERIFY_SMS: 'verifysms',
  RENEWAL_HUB: 'renewalhub',
  MY_PETS: 'mypets',
  ADJUST_POLICY: 'adjustpolicy',
  CONFIRMATION: 'confirmation'
};

export const TAXONOMY_CODENAME = {
  POLICY_COVER: 'meta_data__policycover',
  PLAN_TYPE: 'meta_data__plantype',
  OPTIONAL_BENEFIT_TYPE: 'meta_data__optionalbenefittype'
};

export const WHATS_COVERED_SECTION = {
  WHATS_COVERED: 'whatsCovered',
  WHATS_NOT_COVERED: 'whatsNotCovered',
  ROUTINE_CARE: 'routineCare',
  BOOSTER_CARE: 'boosterCare',
  DISCLAIMER: 'disclaimer'
};

export const RENEWAL_HUB_CONTENT = {
  INTRODUCTION_CONTENT: 'introduction_content',
  ADJUST_COVER: 'adjust_cover',
  OPTIONAL_EXTRAS: 'optional_extras',
  BOOSTER_CARE_CONTENT: 'booster_care__content',
  ROUTINE_CARE_CONTENT: 'routine_care__content',
  EXCESS_TOOLTIP: 'excess_tooltip',
  BENEFIT_PERCENTAGE_TOOLTIP: 'benefit_percentage_tooltip',
  CHANGE_SUMMARY: 'change_summary',
  BOOSTER_CARE_TOOLTIP: 'booster_care_tooltip',
  ROUTINE_CARE_TOOLTIP: 'routine_care_tooltip',
  PANEL_SUMMARY: 'panel_summary'
};

export const RENEWAL_HUB_MODULAR_CONTENT = {
  INTRODUCTION: 'introduction',
  ADJUST_COVER: 'adjust_cover',
  OPTIONAL_EXTRAS: 'optional_extras',
  ADJUST_ANNUAL_EXCESS: 'adjust_annual_excess',
  ADJUST_BENEFIT_PERCENTAGE: 'adjust_benefit_percentage',
  BOOSTER_CARE_OR_EXTRA_CARE: 'booster_care_or_extra_care',
  ROUTINE_CARE: 'routine_care',
  CHANGE_SUMMARY: 'change_summary',
  ANNUAL_EXCESS_DECREASE: 'annual_excess_decrease',
  ANNUAL_EXCESS_INCREASE: 'annual_excess_increase',
  BENEFIT_PERCENTAGE_DECREASE: 'benefit_percentage_decrease',
  BENEFIT_PERCENTAGE_INCREASE: 'benefit_percentage_increase',
  SUBMIT_PREMIUM_STATE_DECREASE: 'submit_premium_state_decrease',
  SUBMIT_PREMIUM_STATE_INCREASE: 'submit_premium_state_increase'
};

export const RENEWAL_HUB_CONTENT_PLACEHOLDER_KEY_MAP = {
  petName: { apiKey: 'PetName', valueType: 'text' },
  benefitPercentage: { apiKey: 'BenefitPercentage', valueType: 'text' },
  routineCare: { apiKey: 'RoutineCare', valueType: 'text' },
  boosterCareName: { apiKey: 'BoosterCareName', valueType: 'text' },
  boosterCareLimit: { apiKey: 'BoosterCareLimit', valueType: 'currency' },
  annualBenefitLimit: { apiKey: 'AnnualBenefitLimit', valueType: 'currency' },
  inceptionDate: { apiKey: 'RenewalStartDate', valueType: 'dateShort' },
  routineCareLimit: { apiKey: 'RoutineCareLimit', valueType: 'currency' },
  brandpartner_phone: { apiKey: 'BrandPartner_Phone', valueType: 'text' },
  excess: { apiKey: 'Excess', valueType: 'currency' },
  premiumAnnual: { apiKey: 'PremiumAnnual', valueType: 'currency' },
  csp_BenefitPercentage: { apiKey: 'csp_BenefitPercentage', valueType: 'text' },
  csp_excess: { apiKey: 'csp_excess', valueType: 'currency' },
  csp_newPremium: { apiKey: 'csp_newPremium', valueType: 'currency' },
  csp_IncludeOrExclude_RoutineCare: { apiKey: 'csp_IncludeOrExclude_RoutineCare', valueType: 'text' },
  csp_IncludeOrExclude_BoosterCare: { apiKey: 'csp_IncludeOrExclude_BoosterCare', valueType: 'text' },
  csp_premiumDiff: { apiKey: 'csp_premiumDiff', valueType: 'currency' },
  premium: { apiKey: 'Premium', valueType: 'currency' },
  firstCollectionDate: { apiKey: 'FirstCollectionDate', valueType: 'dateShort' },
  policyStartDate: { apiKey: 'RenewalStartDate', valueType: 'dateShort' }
};

export const DEFAULT_CONTENT = {
  CONTENT: 'content',
  TITLE: 'title'
};

export const GENERAL_TOOLTIP_CODENAME = {
  EXCESS_PER_CONDITION_TOOLTIP: 'excess_per_condition_tooltip',
  REIMBURSEMENT_UPDATE_TOOLTIP: 'reimbursement_update_tooltip',
  MEDICAL_NOTES_TOOLTIP: 'medical_notes_tooltip',
  NEXT_COLLECTION_AMOUNT_TOOLTIP: 'next_collection_amount_tooltip',
  CLAIM_DOCUMENTS_TOOLTIP: 'claim_documents_tooltip',
  OTHER_DOCUMENTS_TOOLTIP: 'other_documents_tooltip',
  SOLE_AUTHORITY_TOOLTIP: 'sole_authority_tooltip'
};
